import type { UdalostDetail } from '../api/JsdhNotifikaceService/generated/models/UdalostDetail';
import { formatAdresa } from './adresaUdalosti';

export const exportToCSV = (detail: UdalostDetail): void => {
    const headers = ['Jméno', 'Funkce', 'Odpověď', 'Čas odpovědi', 'Doba reakce (s)'];

    const rows = detail.timeline.map(t => [
        t.uzivatelJmeno,
        t.uzivatelFunkce?.map(f => f.kod).join(', ') || '-',
        t.odpoved,
        new Date(t.cas).toLocaleString('cs-CZ'),
        t.dobaReakceSekundy?.toString() || '-'
    ]);

    const csvContent = [
        `Událost: ${detail.udalost}`,
        `Adresa: ${formatAdresa(detail) || '-'}`,
        `Čas vyhlášení: ${new Date(detail.casVyhlaseni).toLocaleString('cs-CZ')}`,
        `Celkem odpovědí: ${detail.pocetOdpovedi}`,
        `JEDU: ${detail.pocetJedu}, NEJEDU: ${detail.pocetNejedu}`,
        '',
        headers.join(';'),
        ...rows.map(row => row.join(';'))
    ].join('\n');

    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `udalost_${detail.id}_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

